import './JiraIssueOptions.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import { Menu } from 'antd';
import React from 'react';
import { SonarText } from '@ui/text';
import { Else, If, Then } from 'react-if';
import { useAction, useCurrentCustomer } from '@hooks';
export const JiraIssuesOptions = ({ hide, initiativeId, issueKey, isSynced }) => {
    const unlinkIssue = useAction(integrationsActions.requestDeleteJiraInitiativesUnlinkIssue);
    const syncJira = useAction(integrationsActions.requestPostInitiativesSyncJiraIssue);
    const unsyncJira = useAction(integrationsActions.requestDeleteInitiativesSyncJiraIssue);
    const customer = useCurrentCustomer();
    const handleOnRemoveIssue = () => {
        unlinkIssue({
            customerId: customer.id,
            initiativeId,
            issueKey
        });
    };
    const handleOnTurnOnStatusSync = () => {
        syncJira({
            customerId: customer.id,
            initiativeId,
            issueKey
        });
        hide();
    };
    const handleOnTurnOffStatusSync = () => {
        unsyncJira({
            customerId: customer.id,
            initiativeId,
            issueKey
        });
        hide();
    };
    return (React.createElement(Menu, null,
        React.createElement(Menu.Item, { onClick: handleOnRemoveIssue },
            React.createElement(SonarText, { className: 'option-text' }, COPY_SPECIFIC.REMOVE_ISSUE)),
        React.createElement(If, { condition: isSynced },
            React.createElement(Then, null,
                React.createElement(Menu.Item, { onClick: handleOnTurnOffStatusSync },
                    React.createElement(SonarText, { className: 'option-text' }, COPY_SPECIFIC.TURN_OFF_STATUS_SYNC))),
            React.createElement(Else, null,
                React.createElement(Menu.Item, { onClick: handleOnTurnOnStatusSync },
                    React.createElement(SonarText, { className: 'option-text' }, COPY_SPECIFIC.TURN_ON_STATUS_SYNC))))));
};
